import useSelectionStore from '@store/useSelectionStore';
import { ClickableType } from '@utils/enums';
import UnitInfoPanel from '../UnitInfoPanel/UnitInfoPanel';
import StructureInfoPanel from '../StructureInfoPanel/StructureInfoPanel';
import ActionsPanel from '../ActionsPanel/ActionsPanel';
import PlannedActionsPanel from '../PlannedActionsPanel/PlannedActionsPanel';
import './InfoPanel.css';

export default function InfoPanel() {
  const { currentClick } = useSelectionStore();

  if (!currentClick) {
    return (
      <div className="info-panel-empty panel-card">
        <p>No selection</p>
      </div>
    );
  }

  return (
    <div className="info-panel panel-card">
      {/* Unit Info Panel - works for both deployed units and deployable units */}
      {(currentClick.type === ClickableType.UNIT || currentClick.type === ClickableType.DEPLOYABLE) && (
        <UnitInfoPanel />
      )}

      {/* Structure Info Panel */}
      {currentClick.type === ClickableType.STRUCTURE && (
        <StructureInfoPanel />
      )}

      {/* Actions Panel - only for deployed units, not deployable */}
      {currentClick.type === ClickableType.UNIT && (
        <ActionsPanel />
      )}

      {/* Planned Actions Panel - shown when clicking on planned actions */}
      {currentClick.type === ClickableType.PLANNED_ACTION && (
        <PlannedActionsPanel />
      )}
    </div>
  );
}